import API_BASE_URL from "../../../../../Constants";

export const fetchAllCustomers = async () => {
  const response = await fetch(`${API_BASE_URL}/api/setup/customers/all`, {
    credentials: "include",
  });
  if (!response.ok) throw new Error("Failed to fetch customers");
  return response.json();
};

export const fetchAssignedCustomers = async (managementID) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers/management/${managementID}`,
      {
        credentials: "include",
      }
    );
    if (!response.ok) throw new Error("Failed to fetch assigned customers");

    const data = await response.json();
    return Array.isArray(data) ? data : []; // Return empty array if data is null or undefined
  } catch (error) {
    console.error("Error fetching assigned customers:", error);
    return []; // Return an empty array on error
  }
};

export const getCustomerById = async (customerID) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/customers/${customerID}`,
    {
      credentials: "include",
    }
  );
  if (!response.ok)
    throw new Error(`Failed to fetch customer with ID ${customerID}`);
  return response.json();
};

export const addCustomer = async (managementID, customerID) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/customers/${customerID}/management`,
    {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ managementID }),
    }
  );
  if (!response.ok) throw new Error("Failed to add customer");
  return response.json();
};

export const removeCustomer = async (managementID, customerID) => {
  try {
    const customer = await getCustomerById(customerID);
    const updatedCustomer = { ...customer, managementID: null };
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers/${customerID}`,
      {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedCustomer),
      }
    );
    if (!response.ok) {
      throw new Error(
        `Failed to update managementID for customer ${customerID}`
      );
    }
    return response.json();
  } catch (error) {
    console.error("Error in removeCustomer function:", error);
    throw error;
  }
};

export const createNewCustomer = async (customerData) => {
  const response = await fetch(`${API_BASE_URL}/api/setup/customers/create`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(customerData),
  });
  if (!response.ok) throw new Error("Failed to create new customer");
  return response.json();
};

export const updateCustomer = async (customerId, customerData) => {
  const response = await fetch(
    `${API_BASE_URL}/api/setup/customers/${customerId}`,
    {
      method: "PUT",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(customerData),
    }
  );
  if (!response.ok) throw new Error("Failed to update customer");
  return response.json();
};

export const fetchCustomersByQuery = async (query) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers/search?q=${encodeURIComponent(
        query
      )}`,
      {
        credentials: "include",
      }
    );
    if (!response.ok) throw new Error("Failed to fetch customers");
    return response.json();
  } catch (error) {
    console.error("Error fetching customers by query:", error);
    return [];
  }
};
